const ThreatItem = ({ name }) => (
  <div className="source-item threat-source-item">
    <span className="source-title">{name}</span>
  </div>
);

export default ThreatItem;
